enum Paths {
  YOUR_BENEFIT_GUIDE = "/your-benefit-guide",
  TALK_TO_CARROT = "/talk-to-carrot",
  REFRESH_CARROT_PLAN = "/talk-to-carrot/refresh-carrot-plan"
}

export { Paths }
